module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS5.64a0fef1.jpg";